import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUpload = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 21,
	width: 20,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m20 19v2h-20v-2zm-10-19a1.02 1.02 0 0 1 .484.125.878.878 0 0 1 .133.088l.008.007.082.073 4 4a1 1 0 1 1 -1.414 1.414l-2.293-2.293v11.586a1 1 0 0 1 -.883.993l-.117.007a1 1 0 0 1 -1-1v-11.586l-2.293 2.293a1 1 0 0 1 -1.414-1.414l4-4 .082-.073.008-.007-.09.08a1.008 1.008 0 0 1 .559-.283.997.997 0 0 1 .148-.01l-.09.004.073-.004z" })
});
export default SvgUpload;
